"use client";

import { HorizontalScrollRail } from "@/components/horizontal-scroll-rail";
import { PopularMenuItemCard } from "./popular-menu-item-card";
import type { Doc } from "../../../convex/_generated/dataModel";

interface PopularMenuGridProps {
  items: Doc<"menu_items">[];
  /** Quick-add guard set forwarded to each card; null disables one-tap add. */
  quickAddRequiredIds?: Set<string> | null;
  /**
   * Opens the shared, surface-level customization sheet for a tapped item.
   * When omitted, each card falls back to its own local (lazy) sheet.
   */
  onSelect?: (item: Doc<"menu_items">) => void;
}

export function PopularMenuGrid({
  items,
  quickAddRequiredIds = null,
  onSelect,
}: PopularMenuGridProps) {
  if (items.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-sm text-muted-foreground">Nothing here yet. The full menu is just below.</p>
      </div>
    );
  }

  return (
    <HorizontalScrollRail
      ariaLabel="Most popular items"
      className="-mx-4 px-4 sm:mx-0 sm:px-0"
      scrollerClassName="gap-3 px-0 pb-2 pt-1"
    >
      {items.map((item, index) => (
        <div
          key={item._id}
          className="w-[216px] flex-shrink-0 snap-start"
        >
          <PopularMenuItemCard
            item={item}
            priority={index === 0}
            quickAddRequiredIds={quickAddRequiredIds}
            onSelect={onSelect}
          />
        </div>
      ))}
    </HorizontalScrollRail>
  );
}
